<div class="p-6 pt-4" [formGroup]="formGroup">
    <h3 class="text-xl mb-2">{{ 'seasons.season-details.dialogs.comment-dialog.title' | translate }}</h3>
    <p class="text-base mb-4">{{ 'seasons.season-details.dialogs.comment-dialog.description' | translate }}</p>
    <sh-input-text
        [label]="'seasons.season-details.dialogs.comment-dialog.label' | translate"
        [value]="formGroup.controls.comment.value"
        textarea
        [rows]="4"
        formControlName="comment"
    ></sh-input-text>
    <div class="flex justify-end mt-2">
        <sh-button
            color="tertiary"
            layout="compact"
            icon="delete"
            iconPosition="left"
            (clicked)="clearComment()"
            [ariaLabel]="'seasons.season-details.dialogs.comment-dialog.delete' | translate"
            [label]="'seasons.season-details.dialogs.comment-dialog.delete' | translate"
        />
    </div>
    <div class="flex justify-end items-center gap-2 mt-4">
        <sh-button
            color="secondary"
            layout="compact"
            icon="arrow-line-left-s"
            iconPosition="left"
            (clicked)="onClose()"
            [ariaLabel]="'seasons.season-details.dialogs.comment-dialog.cancel' | translate"
            [label]="'seasons.season-details.dialogs.comment-dialog.cancel' | translate"
        />
        <sh-button
            layout="compact"
            icon="save"
            iconPosition="left"
            (clicked)="onClose('save')"
            [ariaLabel]="'seasons.season-details.dialogs.comment-dialog.confirm' | translate"
            [label]="'seasons.season-details.dialogs.comment-dialog.confirm' | translate"
        />
    </div>
</div>
